module.exports = __webpack_public_path__ + "static/img/img-fj.afc8953.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img-fj.png
// module id = g9fj
// module chunks = 222